<template>
    <div>
        <!-- Snackbar Component -->
<b-toast id="snackbar"
v-model="showSnackBar" variant="primary" solid toaster="b-toaster-bottom-right"
:auto-hide-delay="timeout" no-close-button
>
<div class="d-flex justify-content-between align-items-center">
  <!-- Message -->
  <span class="text-black">
    {{ msg }}
  </span>

  <!-- Close Button -->
  <b-button
    variant="link"
    class="p-0 ml-2"
    @click="showSnackBar = false"
  >
    <va-icon name="fa fa-close" style="color: #17a2b8;" class="text-black"/>
  </b-button>
</div>
</b-toast>
<va-card class="overflow-auto">
        <vue-element-loading :active="visible" :is-full-screen="true" />
        <div class="row">
          <div class="flex md6 sm6 xs12">
            <h4 style="font-size: 24px !important">SPECIES SCHEDULE</h4>
          </div>
        </div>
        <b-row class="pb-4">
          <b-col cols="12">
            <b-input-group prepend="Search key" class="mt-3">
              <b-form-input
                v-model="keyword"
                placeholder="Please Enter Species Name"
              ></b-form-input>
              <b-input-group-append>
                <b-button variant="info">
                  <i class="fa fa-search"></i>
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>
        <div>
          <h5 style="font-size:17px">*Select the schedule options to filter the results</h5>
        </div>
        <div class="row">
          <div class="flex md4 sm6 xs12">
            <div class="form-group">
              <b-form-group>
                <b-form-select  class="filter pt-2 pb-2"
                  style="width: 100% !important"
                  id="schedule-filter"
                  v-model="scheduleFilter"
                  :options="filterArray"
                  size="lg"
                  :clear-button="false"
                ></b-form-select>
              </b-form-group>
            </div>
          </div>
          <!-- <div class="flex md4 sm6 xs12">
            <div class="form-group">
              <label
                for="exampleInputEmail1"
                style="text-align: left !important"
              ></label>
              <select
                class="filter pt-2 pb-2"
                style="width: 100% !important"
                v-model="status"
              >
                <option value selected disabled hidden>Status</option>
                <option value=" ">All</option>
                <option value="read">Read</option>
                <option value="unread">Unread</option>
                <option value="replied">Replied</option>
              </select>
            </div>
          </div> -->
        </div>
        <div class="flex md12 sm6 xs12 overflow-auto">
          <div class="overflow-aut0" style="overflow: auto">
            <b-table
              hover
              v-if="data.length"
              class="table-sm th table-sm td"
              id="my-table"
              :fields="fields"
              :items="data"
              small
              borderless
              head-variant="dark"
              table-variant="light"
            >
              <template v-slot:cell(sno)="data">
                <span v-if="currentPage > 1">{{
                  (currentPage - 1) * perPage + data.item.sno
                }}</span>
                <span v-else>{{ data.item.sno }}</span>
              </template>
              <!-- <template v-slot:cell(_id)="data">
                <router-link :to="'/guideView/' + data.item._id">
                  <b-button variant="success">View Details</b-button>
                </router-link>
              </template> -->
              <template v-slot:cell(_id)="data">
                <span >
                  <!-- <router-link :to="'/sourceedit/' + data.item._id">
                    <b-button type="submit" variant="info">Update</b-button>
                  </router-link> -->
                  <b-button type="submit"  @click.stop="editSlider(data)" variant="info"
                    >Update</b-button
                  >
                </span>
                <span class="pl-2">
                  <b-button variant="danger" @click="deleteSType(data.item._id)"
                    >Delete</b-button
                  >
                </span>
              </template>
            </b-table>
            <p v-else>No Data Found</p>
            <br />
            <b-pagination
              align="center"
              v-model="currentPage"
              :total-rows="totalData"
              :per-page="perPage"
              prev-text="Prev"
              next-text="Next"
              @change="nextPage"
              aria-controls="my-table"
            ></b-pagination>
            <br />
          </div>
        </div>
      </va-card>

      <!-- Edit Dialog -->
<b-modal id="edit-dialog" 
v-model="editdialog" title="EDIT SPECIES SCHEDULES" size="lg" hide-footer centered ok-only
>
<b-form>
  <b-row class="px-2">
   
    <b-col cols="12" class="pr-2">
      <label class="label" for="bible-quote">Scientific Name</label>
      <b-form-input
        id="scientificName"
        v-model="editingitem.scientificName"
        rows="3"
        class="pt-2 text-des"
        style="font-size: 14px"
        
      ></b-form-input>
    </b-col>

   
    <b-col cols="12" class="pr-2 pt-3">
      <label class="label" for="author">Common Name</label>
      <b-form-input
        id="commonName"
        v-model="editingitem.commonName"
        class="pt-2 text-des"
        style="font-size: 14px"
        
      ></b-form-input>
    </b-col>
  </b-row>
</b-form>

<div class="py-4 d-flex justify-content-end">
  <b-button variant="outline-secondary" @click="closeDialog">Cancel</b-button>
  <b-button variant="primary" class="btn btn-info ml-2"  @click="edit(editingitem._id)">Save</b-button>
</div>
</b-modal>

    </div>
  </template>
  
  <script>
  import axios from "axios";
  import VueElementLoading from "vue-element-loading";
  export default {
    components: {
      VueElementLoading,
    },
    data() {
      return {
        id1: "",
        showSnackBar: false, 
        msg: "",
        timeout: 5000,
        scientificName:null,
        commonName:null,
        visible: false,
        perPage: 20,
        currentPage: 1,
        dat: [],
        editdialog: false,
        editingitem: {},
        keyword: null,
        fields: [
          {
            key: "sno",
            label: "S.No",
            tdClass: "text-left",
            thClass: "text-left",
          },
          {
            key: "scientificName",
            label: "Scientific Name",
            tdClass: "text-left",
            thClass: "text-left",
          },
          {
            key: "commonName",
            label: "Common Name",
            sortable: false,
             tdClass: "text-left",
            thClass: "text-left"
          },
          {
            label: " Action",
            key: "_id",
            sortable: false,
            //  thClass:"pdngtblhead",
            tdClass: "text-left",
            thClass: "text-left"
          },
        ],
        data: [],
        data1: [],
        scheduleFilter: [],
      filterArray: [
        { value: "I", text: "Schedule I" },
        { value: "II", text: "Schedule II" },
        { value: "III", text: "Schedule III" },
        { value: "IV", text: "Schedule IV" },
      ],
        status: "",
        stat: "",
        totalData: "",
       
      };
    },
  
    mounted: function () {
      this.getList();
    },
    computed: {
      rows() {
        return this.data.length;
      },
    },
    watch: {
    //   status: function () {
    //     this.getList();
    //   },
    keyword: function () {
      this.getList();
    },
    scheduleFilter: function () {
        this.getList();
      },
    },
  
    methods: {
        closeDialog() {
      this.editdialog = false;
      this.getList();
    },
      nextPage(ev) {
        this.currentPage = ev;
        this.getList();
      },
      getList() {
        this.visible = true;
        // var data1 = {};
        // // if (this.usertype !== "") {
        // //   data1["usertype"] = this.usertype;
        // // }
        // // if (this.scheduleFilter !== "") {
        // //   data1["scheduleFilter"] = this.scheduleFilter;
        // // }
        // data1["page"] = this.currentPage;
        // data1["limit"] = this.perPage;
        // data1["scheduleFilter"] = this.scheduleFilter;
        // data1["keyword "] = this.keyword ;
        axios({
          method: "get",
          url: "/get/wpa/schedule/list",
          
          headers: {
            token: localStorage.getItem("token"),
          },
          params: {
           
             page: this.currentPage,
             limit: this.perPage,
             scheduleFilter:this.scheduleFilter,
             keyword:this.keyword
        },
        })
          .then((response) => {
            if (response.data.status === true) {
              for (var i = 0; i < response.data.data.length; i++) {
                response.data.data[i].sno = i + 1;
              }
              this.data = response.data.data;
              this.totalData = response.data.totalLength;
  
            //   for (var i = 0; i < this.data.length; i++) {
            //     var dt = this.data[i].create_date;
            //     dt = new Date(dt);
            //     dt = dt.toString();
            //     dt = dt.slice(0, 15);
            //     this.data[i].create_date = dt;
            //   }
              this.visible = false;
            } else if (response.data.status === false) {
              this.visible = false;
            }
          })
          .catch((e) => {
            console.log(e);
            this.visible = false;
            // this.errors.push(e)
            this.msg = "failed";
          });
      },
       editSlider(data) {
      this.editingitem = data.item;
      this.editdialog = true;

    },
    edit() {
      this.appLoading = true;
      var user = {};
      user["id"] = this.editingitem._id;
      user["commonName"] = this.editingitem.commonName;
      user["scientificName"] = this.editingitem.scientificName;
      axios({
        url: "/update/wpa/schedule",
        method: "POST",
        data: user,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.editdialog = false;

            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    deleteSType(id) {
      this.visible = true;
      if (confirm("Are you sure you want to delete this Species ?")) {
        this.visible = true;
        axios({
          method: "POST",

          headers: {
            token: localStorage.getItem("token"),
          },
          url: "/delete/wpa/schedule" + id,
        })
          .then((response) => {
            this.visible = false;
            if (response.data.status) {
              this.getList();
              this.msg = response.data.msg;
            this.showSnackBar = true;
            } else {
                this.msg = response.data.msg;
                this.showSnackBar = true;
            }
          })
          .catch((err) => {
            this.visible = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          });
      } else {
        this.visible = false;
      }
    },
     //   edit(data) {
    //   // this.visible = true
    //   var data1 = {};
    //   data1["sname"] = data.item.sname;
    //   // evt.preventDefault()
    //   axios({
    //     method: "POST",
    //     url: "/source/edit/" + data.item._id,
    //     headers: {
    //       token: localStorage.getItem("token"),
    //     },
    //     data: data1,
    //   })
    //     .then((response) => {
    //       this.msg = response.data.msg;
    //       if (response.data.status === true) {
    //         this.visible = false;
    //         this.$bvToast.toast(this.msg, {
    //           title: `Sources`,
    //           solid: true,
    //           variant: "success",
    //         });
    //       } else {
    //         this.visible = false;
    //         this.$bvToast.toast(this.msg, {
    //           title: `Sources`,
    //           solid: true,
    //           variant: "danger",
    //         });
    //       }
    //     })
    //     .catch((e) => {
    //       console.log(e);
    //     });
    // },
    },
  };
  </script>
  <style scoped>
  .pdngtblcol {
    padding-right: 50px !important;
  }
  .pdngtblcol1 {
    padding-left: 30px !important;
  }
  
  .pdngtblhead {
    padding-top: 30px !important;
    margin-top: 30px !important;
    padding-bottom: 30px !important;
  }
  .thead-dark {
    padding-top: 80px !important;
  }
  .table-sm th,
  .table-sm td {
    padding: 30px !important;
  }
  .filter {
    width: 100% !important;
  }
  .tblbutton {
    text-align: right !important;
    width: 30% !important;
  }
  </style>
  